<template>
  <div>
    <v-chip v-if="!solotexto" :color="getColor(estado.id_estado)" dark>{{
      estado.descripcion_estado
    }}</v-chip>
    <span v-if="solotexto">{{
      estado.descripcion_estado
    }}</span>
  </div>
</template>

<script>
export default {
  props: {
    estado: Object,
    solotexto: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getColor(id_estado) {
      let ret = "lime lighten-4";
      switch (id_estado) {
        case 1:
          ret = "red";
          break;
        case 2:
          ret = "green";
          break;
        case 3:
          ret = "blue";
          break;
        case 4:
          ret = "black";
          break;
        case 5:
          ret = "white";
          break;
        default:
          break;
      }
      return ret;
    },
  },
};
</script>

<style></style>
